//Modules
import React, { createContext, useState, useContext } from 'react';

const HeroImageContext = createContext();

export const HeroImageProvider = ({ children }) => {
  const defaultHeroImage = "./images/heroIllustration.webp";
  const [heroImage, setHeroImage] = useState(defaultHeroImage);

  const defaultHeroText = {
    caption: "/00",
    title: "Constantly creating",
    description: "products that think, and visuals that feel.",
  };

  const [heroText, setHeroText] = useState(defaultHeroText);

const updateHeroImage = (newImageUrl, newText) => {
    const heroImageContainer = document.querySelector('.hero-image');
    if (newText) setHeroText(newText);
    
    if (heroImageContainer) {
      if (newText) setHeroText(newText);

      const incomingImage = document.createElement('div');
      incomingImage.className = 'hero-image incoming';
      incomingImage.style.backgroundImage = `url(${newImageUrl})`;
      incomingImage.style.clipPath = 'inset(100% 0% 0% 0%)';
      heroImageContainer.appendChild(incomingImage);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          incomingImage.style.transition = 'clip-path 0.6s cubic-bezier(0.7, 0, 0.2, 1)';
          incomingImage.style.clipPath = 'inset(0% 0% 0% 0%)';
        });
      });

      setTimeout(() => {
        setHeroImage(newImageUrl);
        heroImageContainer.removeChild(incomingImage);
      }, 600);
    }
  };

  const resetHero = () => {
    updateHeroImage(defaultHeroImage, defaultHeroText);
  };

return (
    <HeroImageContext.Provider value={{ 
      heroImage, 
      heroText,
      setHeroImage: updateHeroImage, 
      defaultHeroImage,
      defaultHeroText,
      resetHero,
    }}>
      {children}
    </HeroImageContext.Provider>
  );
};


export const useHeroImage = () => useContext(HeroImageContext);

